import { Role } from '../enums/Role';
import { useOktaAuth } from '@okta/okta-react';

export const useGetBackofficeRoles = () => {
    const okta = useOktaAuth();

    return okta.authState?.accessToken?.claims['backoffice_role'] as unknown as Role[] || [];
};
